//http://tce.alicdn.com/api/data.htm?ids=897861
//添加完区块后，会将数据放到全局变量 domainDataList 中

//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook, event } = checkApp.core;//eslint-disable-line
const { utils } = checkApp.common;//eslint-disable-line

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('suffixsService', ['request', 'suffixs', 'suffixFilter'], 9999999)
export default class CNSuffixsServiceFeature extends Feature {

  @hook('suffixs.list')
  getList() {
    return window.domainDataList.suffix_list;
  }

  @event('ready')
  onReady() {
    this.suffixFilter.onReady();
  }

  getDetailList() {
    return window.domainDataList.suffix_detail_list;
  }

}


// WEBPACK FOOTER //
// ./src/suffixs/index.js